/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Product reviews methods
 * -----------------------------------------------------------------------------
 *
 * @namespace productReviews
 */

import axios from 'axios';
import Pagination from 'laravel-vue-pagination';
import StarRating from 'vue-star-rating';

// Import FilePond polyfill for IE11 support
import 'filepond-polyfill';

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileEncode);

const host = 'https://reviews.hulkapps.com';
const apiEndPoint = `${host}/api/shop`;

let shopifyId;
// var shopifyDomain = Shopify.shop;
const shopifyDomain = 'hulkapps.myshopify.com';
const apiUrl = 'https://reviews.hulkapps.com/api/shop';
const $reviewsApp = $('[data-product-reviews]');
const productId = $reviewsApp.data('product-id');
const productTitle = $reviewsApp.data('product-title');
const reviewsType = $reviewsApp.data('type');


const productReviewsMethods = {
  components: {
    Pagination,
    StarRating,
    FilePond,
  },
  data() {
    return {
      googleData: '',
      reviewSettings: {},
      allReviews: {
        data: {},
        pagination: {},
      },
      productReviews: {
        data: {},
        pagination: {},
      },
      totalAllReviews: 0,
      totalProductReviews: 0,
      productsRating: [],
      productRating: null,
      collectionRating: null,
      singleReview: {},
      modalReviewsData: {},
      totalReviews: 0,
      totalAllReviews: 0,
      reviewsAvgRating: 0,
      rating: 5,
      userReviewImage: {
        name: null,
        data: null,
      },
      allProductReviews: null,
    };
  },

  methods: {

    _initProductReviews() {
      if(typeof($('[data-current_template]').data('current_template')) == 'string') {
        if (!window.theme.productReviewsEnabled || $('[data-current_template]').data('current_template').includes('blog') || $('[data-current_template]').data('current_template').includes('article') || $('[data-current_template]').data('current_template').includes('page')) {
          return;
        }
      }
      app._getShopReviews();
      app._checkUrlParams();
    },

    _checkUrlParams() {
      // check for URL parameter in order to open the new review modal
      const showReviewForm = app._getUrlParameter('showReviewForm');

      if (showReviewForm === 'true') {
        setTimeout(() => {
          app._showReviewForm();
        }, 1500);
      }
    },

    _scrollToReviews() {
      let $target;

      if (reviewsType === 'productReviews') {
        $target = $('[data-review-tab]');
      } else {
        $target = $('header');
      }

      $('html, body').animate({
        scrollTop: $target.offset().top - 30,
      }, 10);
    },

    _getShopReviews() {
      // first find the Shop Id by providing the shopify domain
      axios.get(`${apiUrl}?shopify_domain=${shopifyDomain}`)
        .then((response) => {
          shopifyId = response.data.data.shopify_id;
          if (!shopifyId && shopifyId !== undefined) {
            return;
          }
          // if (app.currentTemplate === 'product') {
          if (app.currentTemplate == 'product') {
            app._getReviews();
            if ($('body .related-products').length > 0) {
              app._setAllReviews();
            }
          }
          else {
            app._getReviewsAll();
          }
          // app._getCollectionReviews();
          return response;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    _getProductReviews() {
      return axios.get(`${apiUrl}/${shopifyId}/reviews?product_id=${productId}`);
    },

    _getSettings() {
      return axios.get(`${apiUrl}/${shopifyId}/settings`);
    },

    _pushStructuredObj(arr, review) {
      arr.push({
        '@context': 'http://schema.org/',
        '@type': 'Review',
        itemReviewed: {
          '@type': 'Product',
          name: productTitle,
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: app.reviewsAvgRating,
            reviewCount: app.totalReviews,
          },
        },
        author: {
          '@type': 'Person',
          name: review.author,
        },
        name: review.title,
        reviewBody: review.body,
        reviewRating: {
          '@type': 'Rating',
          ratingValue: review.rating,
          bestRating: '5',
        },
      });
    },

    _getCollectionReviews() {

      let productIDs = [];
      let all_reviews = 0;
      $('.reviews-collection-product-id').each(function() {
        productIDs.push($(this).data('collection-product-id'));
      }); 
      productIDs = productIDs.join();

      axios.get(`${apiEndPoint}/${shopifyId}/reviews`)
        // eslint-disable-next-line promise/always-return
        .then((response) => {

          app.totalAllReviews = response.data.total;
          all_reviews = app.totalAllReviews;

          // eslint-disable-next-line promise/no-nesting
          // eslint-disable-next-line promise/catch-or-return
          axios.get(`${apiEndPoint}/${shopifyId}/reviews/ratings?product_ids=${productIDs}`)
          .then((response) => {

            const collectionProductsRatings = response.data.data;

            if(collectionProductsRatings.length) {
              let avg_rating = 0;
              let total_reviews = 0;
              collectionProductsRatings.forEach((collectionProductRating) => {
              
                // eslint-disable-next-line operator-assignment
                avg_rating = avg_rating + +parseFloat(collectionProductRating.avg_rating);
                // total_reviews = total_reviews + +parseFloat(collectionProductRating.total_reviews);
              });

              this.collectionRating = {
                avg_rating: Math.round(avg_rating / collectionProductsRatings.length),
                total_reviews: all_reviews,
              };
            }
          })
      })

        .catch((error) => {
          // console.log(error);
          throw error;
        });

      app._setAllReviews();
    },

    _setAllReviews() {
      let ids;
      let product_id;
      
      setTimeout(() => {
        $('[data-item-reviews]').each(function(i) {
          // eslint-disable-next-line eqeqeq
          if (i == 0) {
            product_id = $(this).attr('data-product-id');
          } else {
            product_id = `${product_id},${$(this).attr('data-product-id')}`;
          }
          ids = product_id;
        });

        if (ids != undefined) {
          axios.get(`${apiUrl}/${shopifyId}/reviews/ratings?product_ids=${ids}`)
            .then((response) => {
              // app.allReviews = response.data.data;
              app.allProductReviews = response.data.data;
              app._setProductCardReviews();
              return response;
            })
            .catch((error) => {
              // console.log(error);
              throw error;
            });
        }
      }, 600);
    },

    _setProductCardReviews() {
      setTimeout(() => {
        $('body').find('[data-item-reviews]').each(function() {
          const productId = $(this).attr('data-product-id');
          const productLink = $(this).attr('data-product-href');
          const itemReviews = app.allProductReviews.filter((itemP) => itemP.product_id == productId);
          let ratingHtml = '';
          let itemHtml = '';
          if (itemReviews.length < 0) {
            $(this).find('.review-div').addClass('d-none');
            for (let i = 0; i < 5; i += 1) {
              if (i < 4) {
                ratingHtml += `<span class="icon-review  itemReviews ion-ios-${app.reviewSettings.rating_symbol}" style="color:${app.reviewSettings.rating_color}"></span>`;
              } else {
                ratingHtml += `<span class="icon-review  itemReviews ion-ios-${app.reviewSettings.rating_symbol}-outline" style="color:${app.reviewSettings.rating_color}"></span>`;
              }
            }
            itemHtml = `<a href="${productLink}?reviews" class="font-weight-bold" style="color:#ffc700;">${ratingHtml}</a>`;

            if ($(this).prev().find('.review-img').length > 0) {
              $(this).html(itemHtml);
            }
            return;
          }

          const totalReviews = itemReviews[0].total_reviews;
          const avgRating = itemReviews[0].avg_rating;
          // const avgRating = Math.round(itemReviews[0].avg_rating);
          for (let i = 0; i < 5; i += 1) {
            if (avgRating > i) {
              let half_star = '';
              if (Math.trunc(avgRating) == i && (avgRating) % 1 != 0) {
                half_star = '-half';
              }
              ratingHtml += `<span class="icon-review ion-ios-${app.reviewSettings.rating_symbol}${half_star} totalReviews-if" style="color:${app.reviewSettings.rating_color}"></span>`;
            } else {
              ratingHtml += `<span class="icon-review ion-ios-${app.reviewSettings.rating_symbol}-outline totalReviews-else" style="color:${app.reviewSettings.rating_color}"></span>`;
            }
          }
          let text = '';
          if (totalReviews) {
            
            if (totalReviews > 1) {
              text = 'reviews';
            } else {
              text = 'review';
            }
            itemHtml = `<a href="${productLink}?reviews" class="font-weight-bold totalReviews-end" style="color:#ffc700;">${ratingHtml}</a>`;
            $(this).find('.product-reviews-avg').text(avgRating.toFixed(1));
            $(this).find('.product-reviews-count').text(`${totalReviews}`);
          }

          $(this).find('.product-reviews').html(itemHtml);
          // dispatch event for the vue match heights directive/plugin
          // document.dispatchEvent(new Event('matchheight'));
          const event = document.createEvent('Event');
          event.initEvent('matchheight', false, true);
          // args: string type, boolean bubbles, boolean cancelable
          document.dispatchEvent(event);
        });
      }, 600);
    },
    
    _getReviews() {
      axios.get(`${apiEndPoint}/${shopifyId}/settings`)
        .then((response) => {

          // eslint-disable-next-line promise/always-return
          if (response.data.data.status) {

            app.reviewSettings = response.data.data;

            app._initProductsRating();

            if (reviewsType === 'allReviews') {

              const reviewAPIEndPoint = `${apiEndPoint}/${shopifyId}/reviews`;
              axios.get(reviewAPIEndPoint)
                .then(response => {
                  $('#HulkAppsReviewsLoader').hide(); 
                  app.allReviews.data = response.data.data;
                  app.allReviews.pagination = response.data;
                  delete app.allReviews.pagination.data;
                  app.totalAllReviews = response.data.total;
                  app.totalProductReviews = response.data.avg_rating;

                  app.$nextTick(() => {

                    // if (reviewsType === 'allReviews' && parseInt(app.totalAllReviews) > 0 && parseInt(app.totalProductReviews) > 0) {
                    //   console.log('called');
                      
                    //   // get current product Ld
                    //   setTimeout(() => {
                    //     app._createAggregateRatingLd();
                    //   }, 300);
                    // }
                    $('[data-product-reviews]').fadeIn();
                  });

                });
            }
          }
        })
        .catch((error) => {
          // console.log(error);
          app.isLoading = false;
          throw error;
        });

      axios.all([
        app._getProductReviews(),
        app._getSettings(),
      ])
        .then(axios.spread((productReviewsRes, settingsRes) => {
          // All requests are now complete
          const settings = settingsRes.data.data;
          const layoutMode = settings.layout_mode;
          const reviews = productReviewsRes.data;
          setTimeout(() => {
            $('#HulkAppsReviewsLoader').hide();  
          }, 300);
          
          // set data
          app.reviewSettings = settings;
          app.productReviews.data = reviews.data;
          app.productReviews.pagination = reviews;
          app.totalReviews = reviews.total;
          app.showReview = true;
          app.reviewsAvgRating = Number(reviews.avg_rating).toFixed(1);
          app.$nextTick(() => {
            // app.isLoading = false

            if (parseInt(app.totalReviews) > 0 && parseInt(app.reviewsAvgRating) > 0) {

              // get current product Ld
              // setTimeout(() => {
                app._createAggregateRatingLd();
              // }, 300);
            }

            $('[data-product-reviews]').fadeIn();

            if (app.productReviews && layoutMode === 'carousel') {
              app._initReviewsCarousel();
            }
          });
        }))
        .catch((error) => {
          // console.log(error);
          app.isLoading = false;
          throw error;
        });
    },

    // all reviews
    _getReviewsAll() {

      axios.get(`${apiEndPoint}/${shopifyId}/settings`)
        .then((response) => {
          // eslint-disable-next-line promise/always-return
          if (response.data.data.status) {
            app.reviewSettings = response.data.data;
            if (reviewsType === "allReviews") {
              const reviewAPIEndPoint = `${apiEndPoint}/${shopifyId}/reviews`;
              // console.log(reviewAPIEndPoint,'all');
              axios.get(reviewAPIEndPoint)
                .then(response => {
                  $('#HulkAppsReviewsLoader').hide();
                  app.allReviews.data = response.data.data;
                  app.allReviews.pagination = response.data;
                  delete app.allReviews.pagination.data;
                  app.showReview = true;
                  app.totalReviews = response.data.total;
                  app.$nextTick(() => {
                    $("[data-product-reviews]").fadeIn();
                  });
                });
            }
            app._getCollectionReviews();
          }
        })
        .catch((error) => {
          // console.log(error);
          app.isLoading = false;
          throw error;
        });
    },

    _getRating(review) {
      const self = this;
      let rating = '';

      for (let i = 0; i < 5; i += 1) {
        if (review.rating > i) {
          rating += `<span class="icon-review ion-ios-${self.reviewSettings.rating_symbol}" style="color:${self.reviewSettings.rating_color}"></span>`;
        } else {
          rating += `<span class="icon-review ion-ios-${self.reviewSettings.rating_symbol}" style="color:#808080"></span>`;
        }
      }
      return rating;
    },

    _getAvgRating() {
      const self = this;
      let rating = '';
      for (let i = 0; i < 5; i += 1) {
        if (app.totalReviews > 0) {
          let half_star = '';
          if (Math.trunc(self.reviewsAvgRating) == i && (self.reviewsAvgRating) % 1 != 0) {
            half_star = '-half';
          }
          if (self.reviewsAvgRating > i) {
            rating += `<span class="icon-review ion-ios-${self.reviewSettings.rating_symbol}${half_star}" style="color:${self.reviewSettings.rating_color}"></span>`;
          } else {
            rating += `<span class="icon-review ion-ios-${self.reviewSettings.rating_symbol}" style="color:#808080"></span>`;
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (i < 4) {
            rating += `<span class="icon-review ion-ios-${self.reviewSettings.rating_symbol}" style="color:${self.reviewSettings.rating_color}"></span>`;
          } else {
            rating += `<span class="icon-review ion-ios-${self.reviewSettings.rating_symbol}-outline" style="color:${self.reviewSettings.rating_color}""></span>`;
          }
        }
      }
      return rating;
    },

    _initProductsRating() {

      const $ratingELs = $('[data-item-reviews]');
      if ($ratingELs.length) {

        const ratingProductIDs = [];
        $ratingELs.each(function() {
          ratingProductIDs.push($(this).data('product-id'));
        });

        axios.get(`${apiEndPoint}/${shopifyId}/reviews/ratings?product_ids=` + ratingProductIDs.join())
          .then(response => {

            let ratings = response.data.data;
            ratings.map(function (o) {
              
                o.avg_rating = Math.round(parseFloat(o.avg_rating));
                o.total_reviews = parseInt(o.total_reviews);

              if (app.currentTemplate === "product" && String(o.product_id) == String(productId)) {
                app.productRating = o;
              }

                return o;
            });
            
            app.productsRating = ratings;
          });
      }
    },

    _getReviewIconsHTML(rating) {

      rating = Math.round(parseFloat(rating));
      
      let reviewIconsHTML = '';
      for (let i = 0; i < 5; i++) {
        const haClass = (rating <= i) ? '-outline' : '';
        reviewIconsHTML += `<span class="icon-review ion-ios-${app.reviewSettings.rating_symbol}${haClass}" style="color: ${app.reviewSettings.rating_color};"></span>`;
      }
      return reviewIconsHTML;
    },

    _getFormattedRating(rating) {

      return Math.round(parseFloat(rating));
    },

    _getTotalCountRating(rating) {

      return rating;
    },

    
    _getPagedResults(page) {
      let reviewsUrl = '';
      app.isLoading = true;
      if (typeof page === 'undefined') {
        page = 1;
      }

      if (reviewsType === 'productReviews') {
        reviewsUrl = `/${shopifyId}/reviews?product_id=${productId}&page=${page}`;
      }

      if (reviewsType === 'allReviews') {
        reviewsUrl = `/${shopifyId}/reviews?page=${page}`;
      }

      axios.get(apiUrl + reviewsUrl)
        .then((response) => {
          if (reviewsType === 'productReviews') {
            app.productReviews.data = response.data.data;
            app.productReviews.pagination = response.data;
            delete app.productReviews.pagination.data;
          }

          if (reviewsType === 'allReviews') {
            app.allReviews.data = response.data.data;
            app.allReviews.pagination = response.data;
            delete app.allReviews.pagination.data;
          }

          app.isLoading = false;
          app._scrollToReviews();
          return response;
        })
        .catch((error) => {
          app.isLoading = false;
          throw error;
        });
    },

    _handleUserFileAdded() {
      const imageData = JSON.parse($('input[name="userReviewImage"').val());
      app.userReviewImage.name = imageData.name;
      app.userReviewImage.data = imageData.data;
    },

    _resetForm() {
      app.rating = 5;
      if (app.reviewSettings.image_upload_enable) {
        this.$refs.userReviewImage.removeFiles();
        app.userReviewImage.name = null;
        app.userReviewImage.data = null;
      }
      $('#newReviewForm')[0].reset();
      $('#newReviewForm').find('input[type="submit"]').removeClass('disabled');
    },

    _showReviewSingle(reviews, reviewId) {
      $('[data-modal-single-review]').modal('show');
      app.modalReviewsData = reviews;
      const review = reviews.find((itemX) => itemX.id === reviewId);

      app.singleReview = review;
      app._checkPagination(reviews, app.singleReview.id);
    },
    _getPrevReview(reviewId) {
      const reviews = app.modalReviewsData;
      const currentItemIndex = reviews.findIndex((itemK) => itemK.id === reviewId);

      if (currentItemIndex > 0) {
        app.singleReview = reviews[currentItemIndex - 1];
      }
      app._checkPagination(reviews, app.singleReview.id);
    },

    _getNextReview(reviewId) {
      const reviews = app.modalReviewsData;
      const currentItemIndex = reviews.findIndex((itemItem) => itemItem.id === reviewId);
      if (currentItemIndex < reviews.length - 1) {
        app.singleReview = reviews[currentItemIndex + 1];
      }
      app._checkPagination(reviews, app.singleReview.id);
    },

    _checkPagination(reviews, reviewId) {
      const currentItemIndex = reviews.findIndex((itemA) => itemA.id === reviewId);

      if (currentItemIndex === 0) {
        $('#prevLink').addClass('disabled');
      } else {
        $('#prevLink').removeClass('disabled');
      }
      if (currentItemIndex === reviews.length - 1) {
        $('#nextLink').addClass('disabled');
      } else {
        $('#nextLink').removeClass('disabled');
      }
    },

    _showReviewForm() {
      app._resetForm();
      $('#response').empty();
      $('[data-modal-new-review]').modal('show');
    },

    _createReview() {
      let successHtml = '';
      let errorsHtml = '';
      const $newReviewForm = $('#newReviewForm');
      const settings = app.reviewSettings;

      const customFields = $("input[name='custom_field[]']").map(function() {
        return {
          id: $(this).attr('data-id'),
          value: $(this).val(),
        };
      }).get();

      const formData = {
        shopify_id: shopifyId,
        product_id: productId,
        product_handle: $newReviewForm.find('input[name=productHandle]').val(),
        product_title: $newReviewForm.find('input[name=productTitle]').val(),
        product_image: $newReviewForm.find('input[name=productImage]').val(),
        author: $newReviewForm.find('input[name=author]').val(),
        email: $newReviewForm.find('input[name=email]').val(),
        title: $newReviewForm.find('input[name=title]').val(),
        body: $newReviewForm.find('textarea[name=body]').val(),
        rating: app.rating,
        custom_fields: customFields,
        image_name: app.userReviewImage.name,
        image_data: app.userReviewImage.data,
      };

      // console.log(JSON.stringify(formData));

      $newReviewForm.find('input[type="submit"]').addClass('disabled').val('Please Wait');

      axios.post(`${apiUrl}/${shopifyId}/reviews`, formData)
        .then((response) => {
          let message;

          if (settings.auto_publish_star && formData.rating >= settings.auto_publish_star) {
            message = 'Review has been successfully submitted. Thank you!';
            app._getReviews();
          } else {
            message = 'Review has been successfully submitted and awaiting for approval. Thank you!';
          }

          $('#newReviewForm').find('input[type="submit"]').val('Submit');
          successHtml = `<div class="alert alert-success">${message}</div>`;
          $('#response').html(successHtml);

          app._resetForm();

          setTimeout(() => {
            $('[data-modal-new-review]').modal('hide');
          }, 5000);

          return response;
        })
        .catch((error) => {
          $('#newReviewForm').find('input[type="submit"]').removeClass('disabled')
            .val('Submit');
          const errors = error.response.data.message;
          errorsHtml = '<div class="alert alert-warning"><ul>';
          $.each(errors, (key, value) => {
            errorsHtml += `<li>${value[0]}</li>`;
          });
          errorsHtml += '</ul></div>';
          $('#response').html(errorsHtml);
          throw error;
        });
    },

    _createAggregateRatingLd() {
      // eslint-disable-next-line radix
      if (app.productRating && parseInt(app.totalAllReviews) > 0) {

        const aggregateRating = {
          // eslint-disable-next-line quotes
          "@type": "AggregateRating",
          // eslint-disable-next-line quote-props
          'ratingValue': app.productRating.avg_rating,
          // eslint-disable-next-line quote-props
          'worstRating': 1,
          // eslint-disable-next-line quote-props
          'bestRating': 5,
          // eslint-disable-next-line quote-props
          'reviewCount': app.productRating.total_reviews,
        };

        let aggregateRatingLd = null;
        $('script[type="application/ld+json"]').each(function() {

          const jsonLd = JSON.parse($(this).html());
          // eslint-disable-next-line eqeqeq
          if (jsonLd['@type'] == 'Product') {

            aggregateRatingLd = jsonLd;
            aggregateRatingLd.aggregateRating = aggregateRating;
            $(this).html(JSON.stringify(aggregateRatingLd, null, 4));
            return false;
          }
        });

        if (!aggregateRatingLd) {

          aggregateRatingLd = {
            // eslint-disable-next-line quotes
            "@context": "http://schema.org/",
            // eslint-disable-next-line quotes
            "@type": "Product",
            // eslint-disable-next-line quote-props
            'name': productTitle,
            // eslint-disable-next-line quote-props
            'aggregateRating': aggregateRating,
          };

          $('#aggregateRatingLd').remove();
          const script = document.createElement('script');
          script.id = 'aggregateRatingLd';
          script.type = 'application/ld+json';
          script.innerHTML = JSON.stringify(aggregateRatingLd, null, 4);
          document.getElementsByTagName('body')[0].appendChild(script);
        }
      } else { 
        if (app.reviewsAvgRating && parseInt(app.totalReviews) > 0) {

        const aggregateRating = {
          // eslint-disable-next-line quotes
          "@type": "AggregateRating",
          // eslint-disable-next-line quote-props
          'ratingValue': Math.round(parseFloat(app.reviewsAvgRating)),
          // eslint-disable-next-line quote-props
          'worstRating': 1,
          // eslint-disable-next-line quote-props
          'bestRating': 5,
          // eslint-disable-next-line quote-props
          'reviewCount': parseInt(app.totalReviews),
        };

        let aggregateRatingLd = null;
        $('script[type="application/ld+json"]').each(function() {

          const jsonLd = JSON.parse($(this).html());
          // eslint-disable-next-line eqeqeq
          if (jsonLd['@type'] == 'Product') {

            aggregateRatingLd = jsonLd;
            aggregateRatingLd.aggregateRating = aggregateRating;
            $(this).html(JSON.stringify(aggregateRatingLd, null, 4));
            return false;
          }
        });

        if (!aggregateRatingLd) {

          aggregateRatingLd = {
            // eslint-disable-next-line quotes
            "@context": "http://schema.org/",
            // eslint-disable-next-line quotes
            "@type": "Product",
            // eslint-disable-next-line quote-props
            'name': productTitle,
            // eslint-disable-next-line quote-props
            'aggregateRating': aggregateRating,
          };

          $('#aggregateRatingLd').remove();
          const script = document.createElement('script');
          script.id = 'aggregateRatingLd';
          script.type = 'application/ld+json';
          script.innerHTML = JSON.stringify(aggregateRatingLd, null, 4);
          document.getElementsByTagName('body')[0].appendChild(script);
        }
      
        }
      }
    },

    _createReviewsLd() {
      // eslint-disable-next-line promise/catch-or-return
      axios.get(`${apiEndPoint}/${shopifyId}/reviews/all`)
        .then((response) => {

          const reviews = response.data.data;
          // eslint-disable-next-line promise/always-return
          if (reviews.length) {

            const reviewsStructuredData = [];
            reviews.forEach((review) => {
              reviewsStructuredData.push({
                '@context': 'http://schema.org/',
                '@type': 'Review',
                // eslint-disable-next-line quote-props
                'itemReviewed': {
                  '@type': 'Product',
                  // eslint-disable-next-line quote-props
                  'name': productTitle,
                },
                // eslint-disable-next-line quote-props
                'author': {
                  '@type': 'Person',
                  // eslint-disable-next-line quote-props
                  'name': review.author,
                },
                // eslint-disable-next-line quote-props
                'name': review.title,
                // eslint-disable-next-line quote-props
                'reviewBody': review.body,
                // eslint-disable-next-line quote-props
                'reviewRating': {
                  '@type': 'Rating',
                  // eslint-disable-next-line quote-props
                  'worstRating': 1,
                  // eslint-disable-next-line quote-props
                  'bestRating': 5,
                  // eslint-disable-next-line quote-props
                  'ratingValue': review.rating,
                }
              });
            });

            $('#reviewsLd').remove();
            const script = document.createElement('script');
            script.id = 'reviewsLd';
            script.type = 'application/ld+json';
            script.innerHTML = JSON.stringify(reviewsStructuredData, null, 4);
            document.getElementsByTagName('body')[0].appendChild(script);
          }
        });
    },

    _createNewProductLd(obj) {
      // remove old script
      $('#productLd').remove();
      const script = document.createElement('script');
      script.id = 'productLd';
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify(obj, null, 4);
      document.getElementsByTagName('body')[0].appendChild(script);
    },

    _initReviewsCarousel() {
      new Flickity('[data-reviews-carousel]', {
        adaptiveHeight: true,
        accessibility: true,
        autoPlay: 5000,
        cellAlign: 'center',
        dragThreshold: 20,
        groupCells: '100%',
        prevNextButtons: true,
        pageDots: true,
        setGallerySize: true,
        wrapAround: false,
        contain: true,
        arrowShape: {
          x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15,
        },
      });
    },

  },
};

export default productReviewsMethods;

